import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import {
  GetCollectionWithItemsOnlyDocument,
  GetCollectionsDocument,
} from 'hooks/useQueries'

type CollectionSsr = {
  items?: unknown
  browse?: unknown
}

type SeedCollection = {
  id?: string | number
  market?: { id?: string | number }
}

// Variables must match the consumers (Items/index.tsx, OtherCollections/index.tsx)
// exactly so the seed shares their Apollo cache key. The id/marketId come from the
// same prehydrated collection prop the page reads. writeQuery is synchronous —
// safe in mini_racer SSR.
const seedCollection = (
  client: ApolloClient<NormalizedCacheObject>,
  ssr: CollectionSsr | undefined,
  collection: SeedCollection | undefined,
): void => {
  if (!ssr || !collection) return

  const id = collection.id?.toString()
  const marketId = collection.market?.id?.toString()

  if (ssr.items && id) {
    try {
      client.writeQuery({
        query: GetCollectionWithItemsOnlyDocument,
        variables: { id },
        data: ssr.items,
      })
    } catch {
      // Best-effort: a malformed payload must not break the render.
    }
  }

  if (ssr.browse && marketId) {
    try {
      client.writeQuery({
        query: GetCollectionsDocument,
        variables: { marketId },
        data: ssr.browse,
      })
    } catch {
      // Best-effort: a malformed payload must not break the render.
    }
  }
}

export default seedCollection
